// import demoHandler from './apiDataManagers/demo_handler';

const client_id = 'aye9-qt1cj-abhrhzy7-m2tup-6x92kc5688';
const client_secret = 'fp329-polk80s-ye04p1yy-45hx874z06';
import { APIgetReportingData } from "../api/target.ts";
async function postReq(url, params) {
  let result = await APIgetReportingData(params,url);

  console.log("GetReportingSumDataFidaV2 Daily Houly - result2"+url, result)
  // if(result.data.response.demoStores) {
  //   console.log("Before demo", demoHandler, params)
  //   result.data.response = demoHandler.toDemo(result.data.response, params.storeCodes)
  // }

  return result;
}

export async function APIGetKpisPlainDataFida(params: any) {
  params.client_id = client_id;
  params.client_secret = client_secret;
  // if (userCheck()) {
  //   return getFakeData(params, false);
  // } else {
    return postReq('/getKpisPlainData', params);
  // }
}
//NEw Apis
//

export function APIGetReportingSumByLocationDataFidaV2(params: any) {
  try
  {
    params.client_id = client_id;
    params.client_secret = client_secret;
    if(params.storeCodes == null || params.storeCodes.length<=0 || params.storeCodes[0]==null)
      {
        return null;
      }
    if(!params.kpiTypes || params.kpiTypes.length == 0 )
      return []
    
    if((params.storeCodes.length == 1 && params.storeCodes[0] == "") || params.startDate ==  null) 
      return []
    else {
      if(params.daysOfWeek) {
        params.days = params.daysOfWeek;
        delete params.daysOfWeek;
        if(typeof params.days === 'string' ) {
          params.days = params.days?.split(',')
        }
      }
      return postReq('/getReportingData', params );
    }
  }
  catch(e) {
    console.log(e)
    return null;
  }
}

export async function APIGetKpisPlainDataFidaV2(params: any) {
  //Power Hour
  params.client_id = client_id;
  params.client_secret = client_secret;
  // if (userCheck()) {
  //   params.kpiTypes = [...params.kpiTypes, 'in', 'out'];
  //   return getFakeData(params, true);
  // } else {
    return postReq('/getKpisPlainData', params);
  // }
}

